import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-primary-100/80 text-primary-700 text-xs font-semibold rounded-full mb-3">
            编辑力荐
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            豆花视频编辑团队精心挑选，每周更新优质内容合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardsData.slice(0, 7).map((card, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer ${
                i === 6 ? 'sm:col-span-2 lg:col-span-3 xl:col-span-4' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 6 ? 'aspect-[21/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-0.5 bg-background-50/90 text-primary-600 text-xs font-semibold rounded-full">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}